import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import {HttpClientAuthServiceService} from '../httpServices/http-client-auth-service.service'
import {GetPromissoryNotesByIdService} from '../httpServices/get-promissory-notes-by-id.service'
@Component({
  selector: 'app-user-test',
  templateUrl: './user-test.component.html',
  styleUrls: ['./user-test.component.css'],
})
export class UserTestComponent implements OnInit {
  title = 'Mundo Financiera';
  users: any[] = [];
  token: any[] = [];
  promiseNotes: any[] = [];

  constructor(protected userService: UserService,protected httpService: HttpClientAuthServiceService, 
    protected getPromissoryService: GetPromissoryNotesByIdService ) {}

  ngOnInit() {
    this.userService.getUsers().subscribe(
      (data) => {
        // Success
        this.users = data['results'];
      },
      (error) => {
        console.error(error);
      }
    );

    this.httpService.login();
  }
}
